<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <!-- 저장 -->
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="saveData">저장하기</button>
        </div>

        <div class="box">
          <admin-box-item title="노트 정보">
            <div class="columns is-multiline">
              <div class="column is-full">
                <admin-form-item label="*노트 제목">
                  <input class="input"
                         style="width:250px"
                         :value="value.title"
                         @input="e=> value.title = e.target.value"
                         type="text">
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="*노트 내용">
                  <lp-editor :text.sync="value.content"></lp-editor>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="파일 첨부">
                  <!--<old-input-file :files.sync="value.files" @remove="idx=>removeIndex(value.files,idx)"></old-input-file>-->
                  <input-file :value.sync="value.file_ext" @setValue="val=>value.files=val"></input-file>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <admin-form-item label="동영상 첨부">
                  <input-video :file.sync="value.video"></input-video>
                </admin-form-item>
              </div>
              <div class="column is-full">
                <lp-check-bool :checked-val.sync="value.activate_comment"
                               label="댓글 활성화 여부"></lp-check-bool>
              </div>
              <div class="column is-full">
                <lp-check-bool :checked-val.sync="value.is_secret"
                               label="비밀글 여부"></lp-check-bool>
              </div>
            </div>
          </admin-box-item>
        </div>

        <div class="box" v-if="post_id > 0">
          <admin-box-item title="댓글 등록">
            <!-- 댓글 목록 -->
            <div>
              <div class="comment-sub-title">
                댓글 목록 ({{ commentsArr.length }})
                <i v-if="isComment===false" @click="isComment=true" class="material-icons" style="cursor: pointer;">keyboard_arrow_down</i>
                <i v-if="isComment===true" @click="isComment=false" class="material-icons" style="cursor: pointer;">keyboard_arrow_up</i>
              </div>
              <div style="padding:12px">
                <div
                  v-if="isComment===true"
                  v-for="(item, idx) in commentsArr" :key="'comments'+idx"
                  style="margin-top: 12px;">
                  <div
                    v-if="idx!==0"
                    style="margin: 15px 0; width: 100%; height: 1px; background: #ddd;"></div>
                  <div style="display:flex; font-size: .9rem; color: #555; justify-content: space-between;">
                    <div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성자</div>
                        <div>{{ item.display_name }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성일</div>
                        <div>{{ item.created_time }}</div>
                      </div>
                      <div style="display: flex;">
                        <div style="width: 80px; font-weight: bold;">작성내용</div>
                        <div>{{ item.content }}</div>
                      </div>
                    </div>
                    <div class="buttons" v-if="!item.is_deleted">
                      <button @click="commentsUpdate(item)" class="button" style="padding: 6px 10px;">수정</button>
                      <button @click="commentsDelete(item)" class="button is-danger" style="padding: 6px 10px;">삭제</button>
                    </div>
                    <div v-else>삭제된 댓글입니다.</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 댓글 작성 -->
            <div>
              <div class="comment-sub-title" style="margin-top:20px;margin-bottom: 20px;">댓글 작성</div>
              <admin-form-item label="작성자" style="margin-bottom:20px">
                관리자
              </admin-form-item>
              <admin-form-item label="작성 내용">
                <div class="flex">
                  <div style="margin-right:12px;width:90%">
                    <textarea class="textarea" v-model="comments.content"></textarea>
                  </div>
                  <div>
                    <button class="button is-primary"
                            style="height: 100% !important"
                            @click="commentsReg">등록</button>
                  </div>
                </div>
              </admin-form-item>
            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
    <div v-if="percentCompleted>0">
      <div :style="pBackground">
      </div>
      <progress-bar :options="progressOptions" :value="percentCompleted" :style="pBarStyle"></progress-bar>
    </div>
  </div>
</template>
<script>
  import LpAdmDropInput from "../../../module/common/LpAdmDropInput";
  import draggable from 'vuedraggable'
  import InputImg from "../../../module/common/InputImg";
  import LpEditor from "../../../module/common/LpEditor";
  import InputFile from "../../../module/common/InputFile";
  import LpCheckBool from "../../../module/common/LpCheckBool";
  import GroupMixin from "@/mixins/GroupMixin"
  import InputVideo from "../../../module/common/InputVideo";
  import OldInputFile from "../../../module/common/OldInputFile";

  export default {
    mixins: [
      GroupMixin
    ],
    components: {
      OldInputFile,
      InputVideo,
      LpCheckBool,
      InputFile,
      LpEditor,
      InputImg,
      LpAdmDropInput,
      draggable
    },
    data() {
      return {
        showFile: false,
        group_id: 0,
        board_id: 0,
        post_id: 0,
        groupList: [],
        value: {
          title:'',
          content:'',
          is_public: true,
          files: [],
          video: '',
          tags:[],
          activate_comment: true,
          is_secret: false
        },
        commentsArr: [],
        // 댓글 작성
        comments: {
          id: "", // 상품문의상세 게시글 id
          content: "",
          /*writer: "",
          writer_type: "",
          writer_name: "",
          writer_username: "",
          date: "",
          lock: false // 비밀댓글 여부*/
        },
        userlist: [],
        isComment: false, // 댓글 목록 fold/unfold
        percentCompleted: 0,
        progressOptions: {
          text: {
            color: '#FFFFFF',
            shadowEnable: true,
            shadowColor: '#000000',
            fontSize: 14,
            fontFamily: 'Helvetica',
            dynamicPosition: false,
            hideText: false
          },
          progress: {
            color: '#2dbd2d',
            backgroundColor: '#333333'
          },
          layout: {
            height: 35,
            width: 140,
            verticalTextAlign: 61,
            horizontalTextAlign: 43,
            zeroOffset: 0,
            strokeWidth: 30,
            progressPadding: 0,
            type: 'line'
          }
        }
      }
    },
    created() {
      this.post_id = this.$route.query.post_id;
      this.board_id = this.$route.query.board_id;
      this.group_id = this.$route.query.group_id;
      this.getData();
      this.getGroupList('groupList');
      if(this.post_id) {
        this.getComment();
      }
    },
    computed: {
      pBackground() {
        return {
          backgroundColor: '#000000',
          opacity: '0.3',
          width: '100%',
          height: '100%',
          top: '0',
          left: '0',
          position: 'fixed',
          zIndex: '1101'
        }
      },
      pBarStyle() {
        return {
          top: '50%',
          left: '50%',
          position: 'fixed',
          zIndex: '1101',
          transform: 'translate(-50%, -50%)'
        }
      },
      selectedGroup() {
        let label = '';
        this.groupList.forEach(item=>{
          if(item.value===this.group_id) {
            label = item.label;
          }
        })
        return label;
      },
    },
    methods: {
      getData() {
        if(this.post_id) {
          this.$axios.get(this.getUrl(`group/${this.group_id}/board/${this.board_id}/post/${this.post_id}`)).then(res=>{
            this.value = res.data;
            this.showFile = true;
          })
        }
        else this.showFile = true;
      },
      saveData() {
        if(!this.value.title) {
          this.toast('제목을 입력하세요.');
          return;
        }
        if(!this.value.content) {
          this.toast('내용을 입력하세요.');
          return;
        }
        // video 타입 File, String
        let isVideo = false;
        if(this.value.video && typeof(this.value.video)==='object') {
          isVideo = true;
        }
        let formData = new FormData();
        formData.append('video', this.value.video);
        delete this.value.video;
        formData.append('jsonData', JSON.stringify(this.value));

        let config = '';
        if(isVideo) {
          let vm = this;
          config = {
            onUploadProgress: function(progressEvent) {
              var percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
              console.log('percent', percentCompleted);
              vm.percentCompleted = percentCompleted;
            }
          };
        }

        if(!isVideo) this.$store.commit('setLoading', true);
        if(this.post_id) {
          this.$axios.patch(this.getUrl(`group/${this.group_id}/board/${this.board_id}/post/${this.post_id}`), formData, config, {
            headers: {
              'Content-Type': 'multipart/form-data',
            }
          }).then(res=>{
            if(res.status===200) {
              if(isVideo) this.percentCompleted=0;
              else this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath(`group/board/post?group_id=${this.group_id}&board_id=${this.board_id}`));
            }
          }).catch(error=>{
            if(isVideo) this.percentCompleted=0;
            else this.$store.commit('setLoading', false);
            this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
          })
        }
        else {
          this.$axios.post(this.getUrl(`group/${this.group_id}/board/${this.board_id}/post`), formData, config, {
            headers: {
              'Content-Type': 'multipart/form-data',
            }
          }).then(res=>{
            if(res.status===200) {
              if(isVideo) this.percentCompleted=0;
              else this.$store.commit('setLoading', false);
              this.toast('저장되었습니다.');
              this.$router.replace(this.getPath(`group/board/post?group_id=${this.group_id}&board_id=${this.board_id}`));
            }
          }).catch(error=>{
            if(isVideo) this.percentCompleted=0;
            else this.$store.commit('setLoading', false);
            this.toast('서버에 오류가 발생했습니다. 관리자에게 문의주세요.');
          })
        }
      },
      getComment() {
        let url = `group/${this.group_id}/board/${this.board_id}/post/${this.post_id}/comment`;
        this.$axios.get(this.getUrl(url))
          .then(res=>{
            this.commentsArr = res.data.data;
            if(res.data.user_type==='admin'){
              this.comment_user_type = 'admin';
              this.comment_user_id = res.data.admin;
            }
            else if(res.data.user_type==='user'){
              this.post_user_type = 'user';
              this.comment_user_id = res.data.user;
            }
          })
      },
      // 삭제
      commentsDelete(item) {
        let url = `group/${this.group_id}/board/${this.board_id}/post/${this.post_id}/comment/${item.id}`;
        this.$axios.delete(this.getUrl(url))
          .then(res=>{
            if(res.status===200){
              this.toast('삭제되었습니다.');
              this.getComment();

              this.comments = {
                id: "",
                content: ""
              }
            }
          })

      },
      // 수정
      commentsUpdate(item) {
        //console.log(item)
        this.comments.id = item.id;
        this.comments.content = item.content;
      },
      // 댓글 등록
      commentsReg() {
        if(!this.comments.id){
          let url = `group/${this.group_id}/board/${this.board_id}/post/${this.post_id}/comment`;
          this.$axios.post(this.getUrl(url), {
            content: this.comments.content,
            user_id: this.comment_user_id,
            user_type: this.comment_user_type
          }).then(res=>{
            if(res.status===200){
              this.getComment();
              this.comments = {
                id: '',
                content: ''
              }
              if(!this.isComment){
                this.isComment = true;
              }
            }
          })

          this.comment_user_id = '';
          this.comment_user_type = '';
          this.comment_username = '';
        }
        else{
          let url = `group/${this.group_id}/board/${this.board_id}/post/${this.post_id}/comment/${this.comments.id}`;
          this.$axios.patch(this.getUrl(url), {
            content: this.comments.content,
            user_id: this.comment_user_id,
            user_type: this.comment_user_type
          }).then(res=>{
            if(res.status===200){
              this.getComment();
              this.comments = {
                id: '',
                content: ''
              }
            }
          })

          this.comment_user_id = '';
          this.comment_user_type = '';
          this.comment_username = '';
        }
      },
      getUserList(){
        this.$axios.get('public/user/whole').then(res=>{
          this.userlist = res.data;
        })
      },
    }
  }
</script>
<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'

  .comment-sub-title {
    background: #ddd;
    color: #333;
    padding: 8px 16px;
    font-size: 0.95rem;
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
  }
</style>
